import React from "react";
import Typography from "@material-ui/core/Typography"

function SenateHome({ user }) {
  // return(<div  style={{marginTop:"35vh", textAlign:"center"}}>voting has closed.</div>)
  return user.level==="600"? <Typography style={{marginTop:"40vh", textAlign:"center"}}>Your class is not eligible to vote for Senate.</Typography>:(
    <div style={{marginTop:"40vh", textAlign:"center"}}>
      <Typography className="head-text" color="primary">
        {" "}
        Click the link below to vote
      </Typography>

      <a href={`/senate/${user.level}/${user._id}`}>Click Here To Vote For Class Rep</a>
    </div>
  )
}

export default SenateHome;
